import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { GbLoginComponent } from './gb-login/gb-login.component'
import { LoginConstants } from './login.constants'

export const routes: Routes = [
  {
    path: LoginConstants.DISTRIBUTOR,
    component: GbLoginComponent,
  },
  {
    path: '',
    component: GbLoginComponent,
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GbDashboardAccountFeatureAuthLoginRoutingModule {}
